/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import configService from './config.service';
import queryString from 'query-string';

export const baseQuery = fetchBaseQuery({
	baseUrl: configService.get('API_URL'),
	paramsSerializer: (params) => {
		const newParams = { ...params };

		for (const key of Object.keys(params)) {
			if (newParams[key] instanceof Date) {
				newParams[key] = newParams[key].toISOString();
			}
		}

		return queryString.stringify(newParams, { arrayFormat: 'bracket' });
	},
});
